import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import api, { formatApiError } from "../api";
import AuthLayout from "../components/AuthLayout";
import { Button, Input, Label } from "../components/ui/Primitives";

export default function SetPasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const isNew = params.get("new") === "1";

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error(t("set_pwd.mismatch"));
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success(t("set_pwd.success"));
      navigate("/login", { replace: true });
    } catch (e2) {
      toast.error(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={isNew ? t("set_pwd.title_new") : t("set_pwd.title_reset")}
      subtitle={isNew ? t("set_pwd.sub_new") : t("set_pwd.sub_reset")}
      footer={
        <Link to="/login" data-testid="set-pwd-back-to-login" className="text-brand hover:text-brand-hover font-medium">
          ← {t("auth.back_to_login")}
        </Link>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4" data-testid="set-pwd-form">
        <div>
          <Label htmlFor="token">{t("set_pwd.token_label")}</Label>
          <Input
            id="token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            required
            className="font-mono text-xs"
            data-testid="set-pwd-token-input"
          />
        </div>
        <div>
          <Label htmlFor="pwd">{t("common.password")}</Label>
          <Input
            id="pwd"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
            data-testid="set-pwd-password-input"
          />
        </div>
        <div>
          <Label htmlFor="pwd2">{t("set_pwd.confirm_label")}</Label>
          <Input
            id="pwd2"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
            data-testid="set-pwd-confirm-input"
          />
        </div>
        <Button type="submit" className="w-full" disabled={loading} data-testid="set-pwd-submit-button">
          {loading ? t("common.loading") : (isNew ? t("set_pwd.submit_new") : t("set_pwd.submit_reset"))}
        </Button>
      </form>
    </AuthLayout>
  );
}
